import { createApiCall } from "services/api/createApiCall";
import { transformOwnerType } from "./transformations";
import { OwnerType } from "./types";


export const getFleetVehicleOwnerTypeAPI = async (): Promise<OwnerType[]> => {

   const response = await createApiCall(
     {
       path: `/v1/fleet/vehicles/owner/types`,
       method: "GET",
     },
     {
       getMessage: {
         error: (error: any) => `${error.response.data.message}`,
       },
     }
   )();
 
  return response.data.map(transformOwnerType);
};
